<script>
    import SecureIcon from "./assets/secure.svg";
    import EthicalIcon from "./assets/ethical.svg";
    import { CheckOutline } from "flowbite-svelte-icons";
</script>

<div class="max-w-6xl mx-auto px-6 md:px-16">
    <h2 class="text-[38px] font-semibold text-navy text-center mb-12 tracking-tight">Our core principles</h2>
    <div class="grid md:grid-cols-2 gap-6">
        <!-- Card 1: Ethical -->
        <div class="bg-white rounded-[8px] p-6 md:p-14 flex flex-col gap-10 items-center" style="box-shadow: 0px 6px 28px 0px rgba(117,81,174,0.2);">
            <div class="flex flex-col gap-6 items-center">
                <div class="flex items-center justify-center rounded-[56px] p-4" style="background-color: #f5f4fd;">
                    <img src={EthicalIcon} alt="" class="w-10 h-10" />
                </div>
                <h3 class="text-[28px] font-semibold text-navy text-center tracking-tight">
                    Ethical &amp; Responsible Use of AI
                </h3>
            </div>
            <ul class="flex flex-col gap-4 w-full">
                <li class="flex items-center gap-4">
                    <CheckOutline class="w-4 h-4 flex-shrink-0" style="color: #6b5ac6;" />
                    <span class="text-[18px] text-navy">AI does not add additional information</span>
                </li>
                <li class="flex items-center gap-4">
                    <CheckOutline class="w-4 h-4 flex-shrink-0" style="color: #6b5ac6;" />
                    <span class="text-[18px] text-navy">AI citations provided</span>
                </li>
                <li class="flex items-center gap-4">
                    <CheckOutline class="w-4 h-4 flex-shrink-0" style="color: #6b5ac6;" />
                    <span class="text-[18px] text-navy">Hallucination checked</span>
                </li>
                <li class="flex items-center gap-4">
                    <CheckOutline class="w-4 h-4 flex-shrink-0" style="color: #6b5ac6;" />
                    <span class="text-[18px] text-navy">Human oversight emphasised during onboarding</span>
                </li>
            </ul>
        </div>

        <!-- Card 2: Security -->
        <div class="bg-white rounded-[8px] p-6 md:p-14 flex flex-col gap-10 items-center" style="box-shadow: 0px 6px 28px 0px rgba(117,81,174,0.2);">
            <div class="flex flex-col gap-6 items-center">
                <div class="flex items-center justify-center rounded-[56px] p-4" style="background-color: #f5f4fd;">
                    <img src={SecureIcon} alt="" class="w-10 h-10" />
                </div>
                <h3 class="text-[28px] font-semibold text-navy text-center tracking-tight">
                    Enterprise-Grade Data Security
                </h3>
            </div>
            <ul class="flex flex-col gap-4 w-full">
                <li class="flex items-center gap-4">
                    <CheckOutline class="w-4 h-4 flex-shrink-0" style="color: #6b5ac6;" />
                    <span class="text-[18px] text-navy">No storage: Data erased after use</span>
                </li>
                <li class="flex items-center gap-4">
                    <CheckOutline class="w-4 h-4 flex-shrink-0" style="color: #6b5ac6;" />
                    <span class="text-[18px] text-navy">SOC-2 &amp; ISO-27001 compliant infrastructure (Microsoft Azure &amp; AWS)</span>
                </li>
                <li class="flex items-center gap-4">
                    <CheckOutline class="w-4 h-4 flex-shrink-0" style="color: #6b5ac6;" />
                    <span class="text-[18px] text-navy">Encryption at rest &amp; in transit</span>
                </li>
                <li class="flex items-center gap-4">
                    <CheckOutline class="w-4 h-4 flex-shrink-0" style="color: #6b5ac6;" />
                    <span class="text-[18px] text-navy">Data never used for AI training</span>
                </li>
            </ul>
            <!-- Cyber Essentials Plus: inline badge + text -->
            <div class="flex gap-6 items-center w-full">
                <div class="flex-shrink-0 overflow-hidden" style="width: 90px; height: 106px;">
                    <iframe src="https://registry.blockmarktech.com/certificates/521b8800-dcf6-44bc-8c7c-0b09ecf73505/widget/?tooltip_position=bottom&theme=transparent" style="border:none;height:106px;width:90px;" title="Cyber Essentials Plus"></iframe>
                </div>
                <p class="text-[18px] text-navy">
                    Cyber Essentials Plus certified.
                    <a href="https://registry.blockmarktech.com/certificates/521b8800-dcf6-44bc-8c7c-0b09ecf73505/" class="underline" target="_blank" rel="noopener noreferrer">Learn more</a>
                </p>
            </div>
        </div>
    </div>
</div>
